  class PTVariablePipe {
      constructor() {
      }
      static get(ind) {
          return pipeVariables[ind];
      }

  }